var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-app"},[_c('h2',{staticClass:"app-title"},[_vm._v("Definições de Comunicação")]),_c('div',{staticClass:"m-t-lg"},[_vm._v(" Indisponível no momento. ")])])
}]

export { render, staticRenderFns }